import { RegionScope } from "~/hooks/useScope";
import { PlatformBreadcrumbs } from "~/pages/platform/components";
import { PoliciesAddPage } from "~/pages/shared/policy/PoliciesAddPage";

export interface PlatformPoliciesAddPageProps {
  scope: RegionScope;
}

export function PlatformPoliciesAddPage({
  scope,
}: PlatformPoliciesAddPageProps) {
  return (
    <PoliciesAddPage
      scope={scope}
      basePath="/policies"
      sectionLabel="Platform Policies"
      breadcrumbs={<PlatformBreadcrumbs currentPage="Add Policies" />}
    />
  );
}
